import { useAddUploadMutation, useGetPresignedUploadMutation } from 'shared/schema'

export const useUpload = (isPublic = true) => {
	const [getPresignedUpload] = useGetPresignedUploadMutation()
	const [addUpload] = useAddUploadMutation()

	const upload = async (file) => {
		const { size, name, type } = file

		const isVideo = type.startsWith('video/')
		if (isVideo && size > 500 * 1024 * 1024) {
			throw new Error('Video files must be under 500MB')
		}

		const prefix = Math.floor(Math.random() * 100000000).toString()
		const fileName = `${prefix}-${name}`.replace(/[^a-zA-Z0-9_.]+/g, '_')

		const result = await getPresignedUpload({
			variables: {
				type,
				fileName,
				isPublic: isPublic
			}
		})
		const { fields, url, presignedGetUrl } = result.data.getPresignedUpload
		console.log('Presigned upload data', fields, url, presignedGetUrl)
		const formData = new FormData()
		for (const [key, value] of Object.entries(fields)) {
			formData.append(key, value)
		}
		formData.append('file', file)
		// Upload the file to S3
		console.log('Uploading to S3', url, formData)
		const s3Response = await fetch(url, {
			method: 'post',
			body: formData
		})
		if (!s3Response.ok) {
			throw new Error(`Upload to storage failed (${s3Response.status})`)
		}
		const newUpload = await addUpload({
			variables: {
				key: `staging/uploads/${fileName}`,
				size,
				type,
				url: presignedGetUrl
			}
		})
		return {
			uploadId: newUpload.data.insertUpload.id,
			publicUrl: newUpload.data.insertUpload.publicUrl,
			mediaType: isVideo ? 'video' : 'image' as 'video' | 'image'
		}
	}

	return [upload]
}
